export function setProducts (state, { competitionId, products }) {
	const existingCompetitionIndex = state.competitions.findIndex(competition => competition.id === competitionId);

	if (existingCompetitionIndex >= 0) {
		return state.competitions[existingCompetitionIndex].products = products;
	}
}
